import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PromotionMetrc from './PromotionMetrc';
import RewardMetrc from './RewardMetrc';
import ComplianceMetrc from './Compliance';
import TaxesMetrc from './taxes';
import MemberMetrc from './MemberMetrc';
import OrderMetrc from './OrderMetrc';
import DeliveryMetrc from './DeliveryFee';
import FeeManagement from './FeeManagement';
import MetrcTab from './MetrcTab';
import { Box } from "@mui/material";

export default function IndexMetrc() {
  const [currentTab, setCurrentTab] = useState('');
  const { search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (search) {
      const selectedTab = search?.split('=')?.[1] || '';
      if (selectedTab !== currentTab) {
        navigate(`/manages/metrc?tab=${selectedTab}`);
        setCurrentTab(selectedTab);
      }
    }
    else {
      navigate('/manages/metrc?tab=promotion');
      setCurrentTab('');
    }
  }, [search]);

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <MetrcTab/>
        {
          currentTab && currentTab === 'promotion' &&
          <PromotionMetrc />

        }
        {
          currentTab === 'reward' &&
          <RewardMetrc />
        }
        {
          currentTab === 'FeeManagement' &&
          <FeeManagement />
        }
        {
          currentTab === 'orders' &&
          <OrderMetrc />
        }
      </Box>
    </CommonLayout>
  );
}